import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB-R9oyNHfCLquMz_CZ1J0V3Fqah4xV2Y0",
  authDomain: "avaami-resource-tracker.firebaseapp.com",
  projectId: "avaami-resource-tracker",
  storageBucket: "avaami-resource-tracker.firebasestorage.app",
  messagingSenderId: "268595588685",
  appId: "1:268595588685:web:136eb3864bc84300783604"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);   // ⭐ IMPORTANT

export default app;